export default __webpack_public_path__ + "static/media/anelkistires_amea.ce7d1b39.svg";